import React, { useState } from 'react';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';
import { Card, Button, Collapse, Row, Col, Badge } from 'react-bootstrap';

const projectContent = [
  {
    title: "Obiectivul programului",
    content: [
      "Crearea unei rețele de companii românești de stat sau mixte, cu sedii în afara țării (UE, SUA, Canada, UK, Golful Persic), care să angajeze români din diaspora și să opereze în domenii-cheie.",
      "Generarea de profit extern pentru statul român și valorificarea competențelor diasporei.",
      "Creșterea influenței economice a României la nivel internațional."
    ]
  },
  {
    title: "Domenii strategice vizate",
    content: [
      "Consultanță IT, AI, software outsourcing",
      "Construcții și renovări civile / industriale",
      "Servicii medicale la domiciliu și pentru rețele private",
      "Transport rutier și logistică internațională",
      "Agribusiness și agroexport",
      "Educație și formare profesională pentru diaspora"
    ]
  },
  {
    title: "Structură organizatorică",
    content: [
      "Agenția Națională pentru Economie Externă și Diaspora (ANEED) – stabilește strategia, identifică piețele și coordonează filialele.",
      "Companii de stat sau mixte (PPP) înființate în țări-cheie, cu angajarea prioritară a românilor din diaspora.",
      "Reprezentanțe permanente în ambasade și consulate pentru integrarea serviciilor de recrutare."
    ]
  },
  {
    title: "Surse de finanțare",
    content: [
      "Bugetul de stat (pentru etapele pilot)",
      "Fonduri europene (InvestEU, Digital Europe, Europa Globală)",
      "Investitori instituționali (BERD, BEI, fonduri suverane)",
      "Parteneriate public-private cu diaspora",
      "Emitere de obligațiuni tematice (diaspora bonds)"
    ]
  },
  {
    title: "Calendar de implementare",
    content: [
      "Fezabilitate: 6 luni – studiu global, selecție piețe, analiză legală",
      "Pilot: 1 an – companii în 3 țări, 500 angajați",
      "Extindere: 2 ani – +7 țări, digitalizare, dezvoltare infrastructură",
      "Maturizare: 5 ani – rețea de peste 25 companii românești active în diaspora"
    ]
  },
  {
    title: "Garanții, control și transparență",
    content: [
      "Control permanent prin ANEED și audit al Curții de Conturi",
      "Publicarea anuală a rapoartelor de activitate și profitabilitate",
      "Platformă digitală „RoGlobal” pentru transparență și înscrierea diasporei"
    ]
  }
];

export default function ProjectDetails() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="w-100" style={{ maxWidth: 900, margin: "48px auto 0 auto" }}>
      <Card className="shadow rounded-4 p-4 border-0" style={{ background: "#f8fafc" }}>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h2 className="h4 fw-bold" style={{ color: "#143685" }}>
            Detalii proiect: U-nite-D – România Globală
          </h2>
          <Button
            variant="light"
            onClick={() => setIsExpanded(v => !v)}
            className="border-0 rounded-circle d-flex align-items-center justify-content-center"
            style={{
              boxShadow: "0 2px 8px #e7eaf1",
              background: "#fff",
              color: "#143685",
              width: 44,
              height: 44
            }}
            aria-label={isExpanded ? "Ascunde detalii" : "Afișează detalii"}
          >
            {isExpanded ? <LuChevronUp size={24} /> : <LuChevronDown size={24} />}
          </Button>
        </div>

        <Collapse in={isExpanded}>
          <div>
            <Row className="gy-4">
              {projectContent.map((section, idx) => (
                <Col xs={12} key={idx}>
                  <Card className="mb-3 border-0 shadow-sm rounded-3" style={{ background: "#f5f7fa" }}>
                    <Card.Body>
                      <h3 className="h5 fw-semibold mb-3 pb-2 border-bottom-yellow" style={{ color: "#143685", borderColor: "#FFC107" }}>
                        {section.title}
                      </h3>
                      <ul className="mb-0 ps-0" style={{ listStyle: "none" }}>
                        {section.content.map((item, itemIdx) => (
                          <li key={itemIdx} className="d-flex align-items-start mb-2">
                            <span
                              style={{
                                width: 8,
                                height: 8,
                                background: "#FFC107",
                                borderRadius: "50%",
                                marginTop: 8,
                                marginRight: 12,
                                flexShrink: 0
                              }}
                            ></span>
                            <span style={{ color: "#000", lineHeight: 1.6 }}>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>

            {/* Impact și parteneri */}
            <Card className="mt-4 border-0 shadow-sm rounded-3" style={{ background: "#f5f7fa" }}>
              <Card.Body>
                <h4 className="fw-semibold mb-3" style={{ color: "#143685" }}>
                  Impact strategic & parteneri
                </h4>
                <Row>
                  <Col md={6}>
                    <h5 className="fw-medium mb-2" style={{ color: "#143685" }}>Impact:</h5>
                    <ul className="mb-3 ps-3" style={{ color: "#000", fontSize: 15 }}>
                      <li>Scăderea ratei de migrație nedefinitivă</li>
                      <li>Crearea unei economii circulare transnaționale românești</li>
                      <li>Repatriere indirectă a capitalului uman și financiar</li>
                      <li>Poziționare a României ca stat exportator de valoare adăugată</li>
                    </ul>
                  </Col>
                  <Col md={6}>
                    <h5 className="fw-medium mb-2" style={{ color: "#143685" }}>Parteneri strategici:</h5>
                    <ul className="mb-3 ps-3" style={{ color: "#000", fontSize: 15 }}>
                      <li>Ministerul Economiei</li> <br/>
                      <li>Ministerul Afacerilor Externe</li> <br/>
                      <li>Ministerul Finanțelor</li> <br/>
                      <li>Reprezentanțele diplomatice române</li> <br/>
                      <li>Comunități și antreprenori români din diaspora</li> <br/>
                      <li>Organizații internaționale (BEI, BERD, OCDE)</li>
                    </ul>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
        </Collapse>

        {!isExpanded && (
          <div className="mt-3 text-center">
            <span className="text-secondary" style={{ fontSize: 14 }}>
              Apăsați pentru a vedea detaliile complete ale proiectului
            </span>
          </div>
        )}
      </Card>
    </div>
  );
}
